/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleVersionState } from './moduleVersionState';
import type { ModuleStateStudentWorkflowState } from './moduleStateStudentWorkflowState';
import type { ModuleStateActiveForCurrentUser } from './moduleStateActiveForCurrentUser';
import type { ModuleStateGradingDue } from './moduleStateGradingDue';

/**
 * Publication, workflow etc. state of a module
 */
export interface ModuleState {
  workflowState: ModuleVersionState;
  studentWorkflowState?: ModuleStateStudentWorkflowState;
  activeForCurrentUser?: ModuleStateActiveForCurrentUser;
  gradingDue?: ModuleStateGradingDue;
}
